import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OrdnerEnum} from '../../core/model/ordner.enum';
import {I18NextPipe} from "@kokos-i18next";
import i18next from "i18next";

@Component({
  selector: 'kokos-postfach-header-search',
    imports: [
        I18NextPipe
    ],
  templateUrl: './postfach-header-search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PostfachHeaderSearchComponent {
  @Input() nachrichtFolder: OrdnerEnum;
  @Input() searchInput: string = '';
  @Input() anzahlNachrichten: number;
  @Output() searchInputChanged = new EventEmitter<string>();

  onSearchInputChanged(event:Event): void {
    this.setSearchInput(( event.target as HTMLInputElement).value);
  }

  setSearchInput(searchInput: string): void {
    if (this.searchInput !== searchInput) {
      this.searchInput = searchInput;
      this.searchInputChanged.emit(searchInput);
    }
  }

  getTitle(folder: OrdnerEnum): string {
    switch (folder) {
      case OrdnerEnum.ERHALTEN:
        return i18next.t("mailbox.inbox");
      case OrdnerEnum.GESENDET:
        return i18next.t("mailbox.sent");
      case OrdnerEnum.GELOESCHT:
        return i18next.t("mailbox.deleted");
      case OrdnerEnum.ENTWURF:
        return i18next.t("mailbox.drafts");
      default: return "undefined";
    }
  }
}
